export type OnboardingTaskKey =
  | "username"
  | "postalCode"
  | "avatar"
  | "bio"
  | "professional";

export interface OnboardingInputs {
  username?: string | null;
  generatedUsername?: string | null;
  hasPostalCode?: boolean;
  hasAvatar?: boolean;
  hasBio?: boolean;
  hasProfessionalAccount?: boolean;
}

export interface OnboardingTask {
  key: OnboardingTaskKey;
  label: string;
  description?: string;
  optional?: boolean;
  completed: boolean;
}

function hasMeaningfulText(value?: string | null) {
  return Boolean(value && value.trim().length > 0);
}

export function getOnboardingTasks({
  username,
  generatedUsername,
  hasPostalCode = false,
  hasAvatar = false,
  hasBio = false,
  hasProfessionalAccount = false,
}: OnboardingInputs): OnboardingTask[] {
  const tasks: OnboardingTask[] = [
    {
      key: "username",
      label: "Personalize your username",
      description: generatedUsername
        ? `We've generated a username for you: @${generatedUsername}`
        : undefined,
      completed:
        hasMeaningfulText(username) &&
        username?.trim() !== generatedUsername?.trim(),
    },
    {
      key: "postalCode",
      label: "Add your postal code",
      description: "Helps us surface nearby businesses and events.",
      completed: hasPostalCode,
    },
    {
      key: "avatar",
      label: "Update your avatar",
      completed: hasAvatar,
    },
    {
      key: "bio",
      label: "Write a short bio",
      completed: hasBio,
    },
    {
      key: "professional",
      label: "Upgrade to a Professional Account",
      description: "Unlock tools for businesses and event organizers.",
      optional: true,
      completed: hasProfessionalAccount,
    },
  ];

  return tasks;
}

export function countCompletedTasks(tasks: OnboardingTask[]): number {
  return tasks.filter((task) => task.completed).length;
}
